export const problems = [
  {
    name: 'sumvec',
    type: 'impera',
  },
  {
    name: 'quicksort',
    type: 'impera',
  },
  {
    name: 'spectacole',
    type: 'greedy',
  },
  {
    name: 'rucsac',
    type: 'greedy',
  },
  {
    name: 'masini',
    type: 'greedy',
  },
  {
    name: 'saritura_cal',
    type: 'greedy',
  },
  {
    name: 'permutari',
    type: 'backtracking',
  },
  {
    name: 'sirpie',
    type: 'backtracking',
  },
  {
    name: 'anagrame',
    type: 'backtracking',
  },
  {
    name: 'dinamica',
    type: 'dynamic',
  },
];
